export default function getResource(label) {
    const resources = {
        savedForLaterTitle: 'Saved For Later',
        viewAll: 'View all',
        remove: 'Remove',
        moveToBasket: 'Move to Basket'
    };

    return resources[label];
}
